<a [href]="galleryItem['media_details']['sizes']['full']['source_url']" [attr.data-article-link]="'/news/article/'+galleryItem.newsArticle.cleanLink" (click)="openGalleryItem($event)">
  <img [src]="galleryItem['media_details']['sizes']['thumbnail']['source_url']" [alt]="galleryItem['alt_text']" class="img-responsive">
</a>
<!--<p class="article-meta img-details">
    <span class="img-timestamp"><i class="fa fa-clock-o"></i>&nbsp;{{ galleryItem.date | date:'M/d/yyy'}}</span>
    <span *ngFor="let category of galleryItem.newsArticle?.categories" class="cat-label">
      <i class="fa fa-bookmark-o"></i>&nbsp;<a [routerLink]="category.link">{{category.name}}</a>&nbsp;
    </span>
</p>-->
